export default __webpack_public_path__ + "static/media/img_21.c7d3c1f9.jpg";